// React Basic and Bootstrap
import React, { Component } from "react";
import { Container, Row, Col, FormGroup, CustomInput, Alert } from "reactstrap";
import { fetchKategoriKeilmuan, fetchMediaTerbitan } from "../../../../api/Front/generalAPI";
import { fetchPenerbitanJenis, fetchPenerbitanKategori, fetchPenerbitanMedia, fetchPenerbitanPerProvinsi, fetchPenerbitanTahunan } from "../../../../api/Front/statistikAPI";

//Import components
import PageBreadcrumb from "../../../../components/Shared/PageBreadcrumb";
import ChartBar from "../Statistik/ChartBar";
import ChartPie from "../Statistik/ChartPie";
import ChartVertical from "./ChartBarVertical";

class PageStatistik extends Component {
    state = {
        pathItems: [
            //id must required
            { id: 1, name: "ISSN - BRIN", link: "/issn" },
            { id: 2, name: "Informasi", link: "#" },
            { id: 3, name: "Statistik Terbitan" },
        ],
        jenis_terbitan: "",
        tahun: "",
        id_kategori: "",
        media_terbitan: "",
        errorMessage: <></>,
        kategori_keilmuan: [],
        media_terbitan_list: [],
        statistikKategoriPendaftaran: <></>,
        statistikKategoriPenerbitan: <></>,
        statistikPenerbitanPerProvinsi: <></>,
        statistikJenisPendaftaran: <></>,
        statistikJenisPenerbitan: <></>,
        statistikMediaPendaftaran: <></>,
        statistikMediaPenerbitan: <></>,
        statistikTahunanPendaftaran: <></>,
        statistikTahunanPenerbitan: <></>,
    };

    componentDidMount() {
        //@ts-ignore
        document.getElementById("brandLogo").className = "d-none";
        document.body?.classList.remove();
        window.addEventListener("scroll", this.scrollNavigation, true);
        this.getKategoriKeilmuan();
        this.getMediaTerbitan();
        this.loadAllData();
    }

    // Make sure to remove the DOM listener when the component is unmounted.
    componentWillUnmount() {
        window.removeEventListener("scroll", this.scrollNavigation, true);
    }

    loadAllData = async () => {
        await this.loadJenisData();
        await this.loadMediaData();
        await this.loadKategoriData();
        await this.getPenerbitanTahunan();
        await this.getPenerbitanPerProvinsi();
        // await this.getPendaftaranTahunan();
    };

    loadJenisData = async () => {
        await this.getPenerbitanJenis();
        // await this.getPendaftaranJenis();
    };

    loadMediaData = async () => {
        await this.getPenerbitanMedia();
        // await this.getPendaftaranMedia();
    };

    loadKategoriData = async () => {
        // await this.getPendaftaranKategori();
        await this.getPenerbitanKategori();
    };

    // getPendaftaranKategori = async () => {
    //     let param = `tahun_filter=${this.state.tahun}&id_kategori=${this.state.id_kategori}`;
    //     let ret = await fetchPendaftaranKategori(param);
    //     if (ret.code === "01") {
    //         this.generateErrorMessage(ret.message);
    //     } else {
    //         let view = await this.generateBarChartVertical(ret.result);
    //         // let view = await this.generateChartPie(ret.result);
    //         this.setState({ statistikKategoriPendaftaran: view });
    //     }
    // };

    getPenerbitanPerProvinsi = async () => {
        let param = `tahun_filter=${this.state.tahun}`;
        let ret = await fetchPenerbitanPerProvinsi(param);
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            let view = await this.generateBarChartVerticalProvinsi(ret.result);
            this.setState({ statistikPenerbitanPerProvinsi: view });
        }
    };

    getPenerbitanKategori = async () => {
        let param = `tahun_filter=${this.state.tahun}&id_kategori=${this.state.id_kategori}`;
        let ret = await fetchPenerbitanKategori(param);
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            let view = await this.generateBarChartVertical(ret.result);
            this.setState({ statistikKategoriPenerbitan: view });
        }
    };
    getPenerbitanJenis = async () => {
        let param = `tahun_filter=${this.state.tahun}&jenis_terbitan=${this.state.jenis_terbitan}`;
        let ret = await fetchPenerbitanJenis(param);
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            try {
                if (ret.result) {
                    let data = ret.result.data_statistik.map((v: any) => {
                        return {
                            name: v.nama_jenis_terbitan,
                            value: v.jumlah,
                        };
                    });
                    let view = <p>Data tidak ditemukan</p>;
                    if (data.length > 0) {
                        view = await this.generateChartPie(data);
                    }
                    this.setState({ statistikJenisPenerbitan: view });
                }
            } catch (error) {
                this.generateErrorMessage("Error Penerbitan - Jenis Terbitan");
            }
        }
    };
    // getPendaftaranJenis = async () => {
    //     let param = `tahun_filter=${this.state.tahun}&jenis_terbitan=${this.state.jenis_terbitan}`;
    //     let ret = await fetchPendaftaranJenis(param);
    //     if (ret.code === "01") {
    //         this.generateErrorMessage(ret.message);
    //     } else {
    //         try {
    //             if (ret.result) {
    //                 let data = ret.result.data_statistik.map((v: any) => {
    //                     return {
    //                         name: v.nama_jenis_terbitan,
    //                         value: v.jumlah,
    //                     };
    //                 });
    //                 let view = <p>Data tidak ditemukan</p>;
    //                 if (data.length > 0) {
    //                     view = await this.generateChartPie(data);
    //                 }
    //                 this.setState({ statistikJenisPendaftaran: view });
    //             }
    //         } catch (error) {
    //             this.generateErrorMessage("Error Pendaftaran - Jenis Terbitan");
    //         }
    //     }
    // };

    getPenerbitanMedia = async () => {
        let param = `tahun_filter=${this.state.tahun}&media_terbitan=${this.state.media_terbitan}`;
        let ret = await fetchPenerbitanMedia(param);
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            try {
                if (ret.result) {
                    let data = ret.result.data_statistik.map((v: any) => {
                        return {
                            name: v.nama_media_terbitan,
                            value: v.jumlah,
                        };
                    });

                    let view = <p>Data tidak ditemukan</p>;
                    if (data.length > 0) {
                        view = await this.generateChartPie(data);
                    }
                    this.setState({ statistikMediaPenerbitan: view });
                }
            } catch (error) {
                this.generateErrorMessage("Error Penerbitan - Media Terbitan");
            }
        }
    };
    // getPendaftaranMedia = async () => {
    //     let param = `tahun_filter=${this.state.tahun}&media_terbitan=${this.state.media_terbitan}`;
    //     let ret = await fetchPendaftaranMedia(param);
    //     if (ret.code === "01") {
    //         this.generateErrorMessage(ret.message);
    //     } else {
    //         try {
    //             if (ret.result) {
    //                 let data = ret.result.data_statistik.map((v: any) => {
    //                     return {
    //                         name: v.nama_media_terbitan,
    //                         value: v.jumlah,
    //                     };
    //                 });

    //                 let view = <p>Data tidak ditemukan</p>;
    //                 if (data.length > 0) {
    //                     view = await this.generateChartPie(data);
    //                 }
    //                 this.setState({ statistikMediaPendaftaran: view });
    //             }
    //         } catch (error) {
    //             this.generateErrorMessage("Error Pendaftaran - Media Terbitan");
    //         }
    //     }
    // };

    getPenerbitanTahunan = async () => {
        let ret = await fetchPenerbitanTahunan();
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            try {
                if (ret.result) {
                    let data = ret.result.data_statistik.map((v: any) => {
                        return {
                            name: v.tahun,
                            value: v.jumlah,
                        };
                    });

                    let view = await this.generateBarChart(data);
                    this.setState({ statistikTahunanPenerbitan: view });
                }
            } catch (error) {
                this.generateErrorMessage("Error Penerbitan - Penerbitan Tahunan");
            }
        }
    };

    // getPendaftaranTahunan = async () => {
    //     let ret = await fetchPendaftaranTahunan();
    //     if (ret.code === "01") {
    //         this.generateErrorMessage(ret.message);
    //     } else {
    //         try {
    //             if (ret.result) {
    //                 let data = ret.result.data_statistik.map((v: any) => {
    //                     return {
    //                         name: v.tahun,
    //                         value: v.jumlah,
    //                     };
    //                 });

    //                 let view = await this.generateBarChart(data);
    //                 this.setState({ statistikTahunanPendaftaran: view });
    //             }
    //         } catch (error) {
    //             this.generateErrorMessage("Error Pendaftaran - Pendaftaran Tahunan");
    //         }
    //     }
    // };

    getKategoriKeilmuan = async () => {
        let ret = await fetchKategoriKeilmuan();
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            let data = await this.generateSelect(ret.result, "Kategori Keilmuan");
            this.setState({ kategori_keilmuan: data });
        }
    };
    getMediaTerbitan = async () => {
        let ret = await fetchMediaTerbitan();
        if (ret.code === "01") {
            this.generateErrorMessage(ret.message);
        } else {
            let data = await this.generateSelect(ret.result, "Media Terbitan");
            this.setState({ media_terbitan_list: data });
        }
    };

    generateSelect = async (param: any, title: string) => {
        let katGen = [];
        katGen.push({ value: "", label: `Semua ${title}` });
        if (param) {
            param.map((v: { id: string; text: string }) => {
                katGen.push({ value: v.id, label: v.text });
                return null;
            });
        }
        return katGen;
    };
    generateBarChartVertical = async (param: any) => {
        let base_height = 200;
        let data = param.data_statistik.map((v: any) => {
            base_height = base_height + 18;
            return {
                name: v.nama_kategori,
                terbitan: v.jumlah,
                persentase: v.persentase,
            };
        });
        let ret = <p>Data tidak ditemukan</p>;
        if (data.length > 0) {
            ret = <ChartVertical total={param.total} data={data} base_height={base_height}></ChartVertical>;
        }
        return ret;
    };

    generateBarChartVerticalProvinsi = async (param: any) => {
        let base_height = 200;
        let data = param.data_statistik.map((v: any) => {
            base_height = base_height + 18;
            return {
                name: v.nama_provinsi,
                terbitan: v.jumlah,
                persentase: v.persentase,
            };
        });
        let ret = <p>Data tidak ditemukan</p>;
        if (data.length > 0) {
            ret = <ChartVertical total={param.total} data={data} base_height={base_height}></ChartVertical>;
        }
        return ret;
    };

    generateBarChart = async (param: any) => {
        let ret = <p>Data tidak ditemukan</p>;
        if (param.length > 0) {
            ret = <ChartBar data={param}></ChartBar>;
        }
        return ret;
    };

    generateChartPie = async (param: any) => {
        const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
        const RADIAN = Math.PI / 180;
        const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }: any) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * RADIAN);
            const y = cy + radius * Math.sin(-midAngle * RADIAN);

            return (
                <text x={x} y={y} fill="white" textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
                    {`${(percent * 100).toFixed(0)}%`}
                </text>
            );
        };

        let ret = <ChartPie data={param} render={renderCustomizedLabel} color={COLORS} />;
        return ret;
    };

    generateErrorMessage = (message: string = "") => {
        if (message !== "") {
            let error_message = (
                <Row className="justify-content-center">
                    <Col lg={4}>
                        <Alert className="mt-3 mb-3" color="danger">
                            {" "}
                            {message}{" "}
                        </Alert>
                    </Col>
                </Row>
            );
            this.setState({ errorMessage: error_message });
            console.log(error_message);
        } else {
            this.setState({ errorMessage: "" });
            console.log("");
        }
    };

    scrollNavigation = () => {
        var doc = document.documentElement;
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top > 80) {
            document.getElementById("topnav")?.classList.add("nav-sticky");
        } else {
            document.getElementById("topnav")?.classList.remove("nav-sticky");
        }
    };

    dateNowYear = () => {
        return new Date().getFullYear();
    };

    dataFullYear = () => {
        let year: any[] = [];
        var start_year = this.dateNowYear();
        year.push({ value: "", label: "Semua Tahun" });
        for (var i = start_year; i > 2000; i--) {
            const s = { value: i, label: i };
            year.push(s);
        }
        return year;
    };

    onChangeJenis = async (param: string) => {
        this.setState({
            jenis_terbitan: param,
        });
    };
    onChangeKategori = async (param: string) => {
        this.setState({
            id_kategori: param,
        });
    };
    onChangeMedia = async (param: string) => {
        this.setState({
            media_terbitan: param,
        });
    };
    onChangeTahun = async (param: string) => {
        this.setState({
            tahun: param,
        });
    };

    render() {
        return (
            <React.Fragment>
                {/* breadcrumb */}
                <PageBreadcrumb title="About Us" pathItems={this.state.pathItems} />
                <div className="position-relative">
                    <div className="shape overflow-hidden text-white">
                        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                        </svg>
                    </div>
                </div>

                <section className="section">
                    <Container className="mt-100 mt-2">
                        {this.state.errorMessage}
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <div className="section-title">
                                    <h4 className="title mb-4">Statistik ISSN</h4>
                                    <p className="text-muted para-desc mx-auto">
                                        Berikut merupakan Statistik Masyarakat yang mendaftarkan ISSN Badan Riset dan Inovasi Nasional (disingkat{" "}
                                        <span className="text-primary font-weight-bold">BRIN</span>) merupakan Lembaga Pemerintah Non Kementerian Republik Indonesia yang dikoordinasikan oleh
                                        Kementerian Negara Riset, Teknologi dan Pendidikan Tinggi (KMNRT).
                                    </p>
                                </div>

                                <Row>
                                    <Col lg={12} className="mt-4 pt-2 pb-4" id="select-box">
                                        <Row>
                                            <Col lg={6}>
                                                <div className="pl-4 pr-4 pt-3">
                                                    <FormGroup className="mb-0">
                                                        <CustomInput
                                                            onChange={async (e) => {
                                                                await this.onChangeTahun(e.target.value);
                                                                await this.loadAllData();
                                                            }}
                                                            name="customSelect"
                                                            id="customSelect1"
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            {this.dataFullYear().map((_v: any, key: number) => {
                                                                return (
                                                                    <option key={key} value={_v.value}>
                                                                        {_v.label}
                                                                    </option>
                                                                );
                                                            })}
                                                        </CustomInput>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="pl-4 pr-4 pt-3">
                                                    <FormGroup className="mb-0">
                                                        <CustomInput
                                                            onChange={async (e) => {
                                                                await this.onChangeKategori(e.target.value);
                                                                await this.loadKategoriData();
                                                            }}
                                                            name="customSelect"
                                                            id="customSelect2"
                                                            type="select"
                                                            className="form-control"
                                                            defaultValue=""
                                                        >
                                                            {this.state.kategori_keilmuan.map((v: any, key: number) => {
                                                                return (
                                                                    <option key={key} value={v.value}>
                                                                        {v.label}
                                                                    </option>
                                                                );
                                                            })}
                                                        </CustomInput>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="pl-4 pr-4 pt-3">
                                                    <FormGroup className="mb-0">
                                                        <CustomInput
                                                            onChange={async (e) => {
                                                                await this.onChangeJenis(e.target.value);
                                                                await this.loadJenisData();
                                                            }}
                                                            name="customSelect"
                                                            id="customSelect3"
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            <option defaultValue="true" value="">
                                                                Semua Jenis Terbitan
                                                            </option>
                                                            <option value="Ilmiah">Ilmiah</option>
                                                            <option value="Popular">Popular</option>
                                                        </CustomInput>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="pl-4 pr-4 pt-3">
                                                    <FormGroup className="mb-0">
                                                        <CustomInput
                                                            onChange={async (e) => {
                                                                await this.onChangeMedia(e.target.value);
                                                                await this.loadMediaData();
                                                            }}
                                                            name="customSelect"
                                                            id="customSelect4"
                                                            type="select"
                                                            className="form-control"
                                                        >
                                                            {this.state.media_terbitan_list.map((v: any, key: number) => {
                                                                return (
                                                                    <option key={key} value={v.value}>
                                                                        {v.label}
                                                                    </option>
                                                                );
                                                            })}
                                                        </CustomInput>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    {/* <Col lg="6">
                                        <p className="text-dark para-desc mx-auto">Jumlah Pendaftar Pertahun</p>
                                        <ChartBar />
                                    </Col>
                                    <Col lg="6">
                                        <p className="text-dark para-desc mx-auto">Jumlah Yang Di Setujui Pertahun</p>
                                        <ChartBar />
                                    </Col> */}
                                    {/* <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Pendaftaran Berdasarkan Jenis Terbitan</p>
                                        {this.state.statistikJenisPendaftaran}
                                    </Col> */}
                                    <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Penerbitan Berdasarkan Jenis Terbitan</p>
                                        {this.state.statistikJenisPenerbitan}
                                    </Col>
                                    {/* <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Pendaftaran Berdasarkan Media Terbitan</p>
                                        {this.state.statistikMediaPendaftaran}
                                    </Col> */}
                                    <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Penerbitan Berdasarkan Media Terbitan</p>
                                        {this.state.statistikMediaPenerbitan}
                                    </Col>
                                    <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Penerbitan Berdasarkan Provinsi</p>
                                        {this.state.statistikPenerbitanPerProvinsi}
                                    </Col>

                                    <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Penerbitan Berdasarkan Kategori</p>
                                        {this.state.statistikKategoriPenerbitan}
                                    </Col>
                                    {/* <Col lg="6" className="pt-5">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Pendaftaran Tahunan</p>
                                        {this.state.statistikTahunanPendaftaran}
                                    </Col> */}

                                    <Col lg="12" className="pt-5 center-block">
                                        <p className="text-dark para-desc mx-auto font-weight-bold">Statistik Penerbitan Tahunan</p>
                                        {this.state.statistikTahunanPenerbitan}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <div className="position-relative">
                    <div className="shape overflow-hidden text-footer">
                        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                        </svg>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default PageStatistik;
